import React, { useState } from 'react';
import './planeerrem.css';
import Navbar from '../../Navbar/nbar';
import Footer from '../../footer/Footer';
import { send } from 'emailjs-com';
import { ReactComponent as CheckIcon } from '../../../assets/icons/circlecheck-svgrepo-com.svg';
import { ReactComponent as MailIcon } from '../../../assets/icons/mail-plus-svgrepo-com.svg';
import { ReactComponent as UserIcon } from '../../../assets/icons/user-svgrepo-com.svg';
import { ReactComponent as DownloadIcon } from '../../../assets/icons/download-minimalistic-svgrepo-com.svg';
import { ReactComponent as LoaderIcon } from '../../../assets/icons/loader-svgrepo-com.svg';

/* ═══════════════════════════════════════
   SVG ILLUSTRATIONS
   ═══════════════════════════════════════ */
function IllustrationDashboard() {
  return (
    <svg viewBox="0 0 280 200" fill="none" className="exp__illust">
      <rect x="10" y="10" width="260" height="180" rx="12" fill="#F9F6FC" stroke="#E8E8F0" strokeWidth="1.5"/>
      <rect x="22" y="22" width="100" height="10" rx="3" fill="#4f297e" opacity="0.15"/>
      <rect x="22" y="42" width="70" height="6" rx="2" fill="#E8E8F0"/>
      <rect x="22" y="58" width="236" height="1" fill="#F0F0F5"/>
      {/* Mini bar chart */}
      <rect x="30" y="130" width="18" height="40" rx="3" fill="#4f297e" opacity="0.2"/>
      <rect x="56" y="110" width="18" height="60" rx="3" fill="#4f297e" opacity="0.35"/>
      <rect x="82" y="90" width="18" height="80" rx="3" fill="#4f297e" opacity="0.5"/>
      <rect x="108" y="100" width="18" height="70" rx="3" fill="#4f297e" opacity="0.4"/>
      <rect x="134" y="80" width="18" height="90" rx="3" fill="#1A8A63" opacity="0.5"/>
      <rect x="160" y="70" width="18" height="100" rx="3" fill="#1A8A63" opacity="0.65"/>
      {/* Donut */}
      <circle cx="220" cy="120" r="35" fill="none" stroke="#E8E8F0" strokeWidth="10"/>
      <circle cx="220" cy="120" r="35" fill="none" stroke="#4f297e" strokeWidth="10" strokeDasharray="110 110" strokeLinecap="round" transform="rotate(-90 220 120)"/>
      <circle cx="220" cy="120" r="35" fill="none" stroke="#1A8A63" strokeWidth="10" strokeDasharray="50 170" strokeLinecap="round" transform="rotate(110 220 120)"/>
      {/* Metric cards */}
      <rect x="22" y="68" width="72" height="44" rx="6" fill="white" stroke="#E8E8F0" strokeWidth="1"/>
      <rect x="30" y="76" width="40" height="6" rx="2" fill="#4f297e" opacity="0.3"/>
      <rect x="30" y="88" width="50" height="10" rx="2" fill="#4f297e" opacity="0.12"/>
      <rect x="102" y="68" width="72" height="44" rx="6" fill="white" stroke="#E8E8F0" strokeWidth="1"/>
      <rect x="110" y="76" width="40" height="6" rx="2" fill="#1A8A63" opacity="0.3"/>
      <rect x="110" y="88" width="50" height="10" rx="2" fill="#1A8A63" opacity="0.12"/>
    </svg>
  );
}

function IllustrationShield() {
  return (
    <svg viewBox="0 0 120 140" fill="none" className="exp__illust-sm">
      <path d="M60 10L15 30v35c0 30 18 57 45 65 27-8 45-35 45-65V30L60 10z" fill="#F9F6FC" stroke="#4f297e" strokeWidth="2" opacity="0.6"/>
      <path d="M60 25L25 41v28c0 24 14 46 35 52 21-6 35-28 35-52V41L60 25z" fill="white" stroke="#E8E8F0" strokeWidth="1.5"/>
      <polyline points="42 68 54 80 78 56" fill="none" stroke="#1A8A63" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

function IllustrationChart() {
  return (
    <svg viewBox="0 0 120 100" fill="none" className="exp__illust-sm">
      <rect x="5" y="5" width="110" height="90" rx="10" fill="#F9F6FC" stroke="#E8E8F0" strokeWidth="1.5"/>
      <polyline points="15 75 35 55 50 62 70 35 90 42 105 20" fill="none" stroke="#4f297e" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <polyline points="15 75 35 65 50 70 70 50 90 55 105 38" fill="none" stroke="#1A8A63" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" opacity="0.6"/>
      <circle cx="70" cy="35" r="4" fill="#4f297e"/>
      <circle cx="105" cy="20" r="4" fill="#4f297e"/>
    </svg>
  );
}

function IllustrationGears() {
  return (
    <svg viewBox="0 0 120 100" fill="none" className="exp__illust-sm">
      <circle cx="45" cy="45" r="22" fill="#F9F6FC" stroke="#4f297e" strokeWidth="2" opacity="0.5"/>
      <circle cx="45" cy="45" r="10" fill="white" stroke="#4f297e" strokeWidth="2" opacity="0.5"/>
      <circle cx="80" cy="62" r="16" fill="#F9F6FC" stroke="#1A8A63" strokeWidth="2" opacity="0.5"/>
      <circle cx="80" cy="62" r="7" fill="white" stroke="#1A8A63" strokeWidth="2" opacity="0.5"/>
      {/* Gear teeth - large */}
      {[0,45,90,135,180,225,270,315].map(a => (
        <rect key={a} x="42" y="20" width="6" height="8" rx="1.5" fill="#4f297e" opacity="0.3" transform={`rotate(${a} 45 45)`}/>
      ))}
      {/* Gear teeth - small */}
      {[0,60,120,180,240,300].map(a => (
        <rect key={a} x="78" y="43" width="4" height="6" rx="1" fill="#1A8A63" opacity="0.3" transform={`rotate(${a} 80 62)`}/>
      ))}
    </svg>
  );
}

/* ═══════════════════════════════════════
   DATA
   ═══════════════════════════════════════ */
const PLATFORM_FEATURES = [
  { title: 'Smart Budgeting', desc: 'Interactive tools that break down income, expenses, and savings ratios with real-time visual feedback — so you always know where your money goes.', icon: 'budget' },
  { title: 'Financial Health Score', desc: 'A comprehensive score computed from your savings rate, debt load, insurance coverage, and investment discipline — updated as you adjust inputs.', icon: 'health' },
  { title: 'Literacy Dashboard', desc: 'Personalised educational content, quizzes, and glossaries adapted to your occupation, income range, and financial experience level.', icon: 'learn' },
  { title: 'Goal-Based Planning', desc: 'Reverse-engineer any financial goal — retirement, home purchase, education — into the monthly SIP or lump sum needed today.', icon: 'goal' },
  { title: 'Investment Comparison', desc: 'See how your money grows across savings accounts, FDs, PPF, debt funds, equity funds, and ELSS — side by side, year by year.', icon: 'compare' },
  { title: 'Enterprise Analytics', desc: 'For businesses: cash flow forecasting, receivables tracking, compliance automation, and ROI calculators — all in one command centre.', icon: 'enterprise' },
];

const HOW_IT_WORKS = [
  { step: '01', title: 'Build Your Profile', desc: 'Answer a few quick questions about your age, income, goals, and experience. Takes under 2 minutes.' },
  { step: '02', title: 'Get Your Roadmap', desc: 'Receive a personalised financial snapshot with your health score, key ratios, risk profile, and action plan.' },
  { step: '03', title: 'Explore Tools', desc: 'Use interactive calculators for SIP projections, EMI planning, inflation impact, and goal-based investing.' },
  { step: '04', title: 'Learn & Grow', desc: 'Read curated articles, take quizzes, and track milestones as you build financial literacy over time.' },
];

const USE_CASES = [
  { who: 'Individuals', items: ['Monthly budget planning with 50-30-20 analysis', 'SIP and EMI calculators with compound growth charts', 'Personalised financial health scoring', 'Tax planning guidance across 80C, 80D, NPS'], accent: '#4f297e' },
  { who: 'Students & Early Career', items: ['Zero-to-emergency-fund playbook', 'First investment guidance and risk profiling', 'Financial glossary with 16+ key terms explained', 'Occupation-specific tips and schemes'], accent: '#1A8A63' },
  { who: 'Businesses & MSMEs', items: ['Cash flow and runway analysis dashboards', 'ROI calculator for operational automation', 'Compliance reporting tools (GST, TDS)', 'Multi-entity financial command centre'], accent: '#A67C00' },
];

const FAQ_DATA = [
  { q: 'Is SOMFIN free to use?', a: 'The financial literacy dashboard, budget tools, and educational content are available at no cost. Enterprise features for businesses are available under separate plans — contact us for details.' },
  { q: 'Does SOMFIN provide financial advice?', a: 'No. SOMFIN is an educational and analytical platform. All content is for general awareness and informational purposes only. We do not provide regulated financial advice, investment recommendations, or portfolio management services. Please consult a qualified financial advisor for personalised guidance.' },
  { q: 'How is my data protected?', a: 'We use industry-standard encryption for data in transit and at rest. We do not sell or share your personal information with third parties. All calculations happen in your browser — your financial data is not stored on our servers unless you explicitly create an account.' },
  { q: 'What does the Beta Tester program include?', a: 'Beta testers get early access to new features before public release, the ability to provide direct feedback that shapes our product roadmap, and a free copy of our financial planning guide.' },
  { q: 'Can businesses use SOMFIN?', a: 'Yes. Our business platform includes cash flow analytics, compliance automation, risk dashboards, and an ROI calculator. Visit the Business page or schedule a demo to learn more about enterprise capabilities.' },
  { q: 'Is the content specific to India?', a: 'Yes. Our tools, tax planning guidance, and financial frameworks are designed specifically for the Indian financial ecosystem — covering EPF, PPF, NPS, ELSS, GST, Section 80C/80D, and Indian mutual fund categories.' },
];

/* ═══════════════════════════════════════
   FEATURE ICON COMPONENT
   ═══════════════════════════════════════ */
function FeatureIcon({ type }) {
  const icons = {
    budget: <><rect x="3" y="3" width="18" height="18" rx="3" fill="none" strokeWidth="1.8"/><line x1="7" y1="9" x2="17" y2="9" strokeWidth="1.5" strokeLinecap="round"/><line x1="7" y1="13" x2="14" y2="13" strokeWidth="1.5" strokeLinecap="round"/><line x1="7" y1="17" x2="11" y2="17" strokeWidth="1.5" strokeLinecap="round"/></>,
    health: <><path d="M12 21C12 21 4 14 4 8.5C4 5.46 6.46 3 9.5 3C11.06 3 12 4 12 4S12.94 3 14.5 3C17.54 3 20 5.46 20 8.5C20 14 12 21 12 21Z" fill="none" strokeWidth="1.8" strokeLinejoin="round"/></>,
    learn: <><path d="M2 7l10-4 10 4-10 4L2 7z" fill="none" strokeWidth="1.8" strokeLinejoin="round"/><path d="M6 9v6c0 2 2.7 4 6 4s6-2 6-4V9" fill="none" strokeWidth="1.8"/></>,
    goal: <><circle cx="12" cy="12" r="9" fill="none" strokeWidth="1.8"/><circle cx="12" cy="12" r="5" fill="none" strokeWidth="1.8"/><circle cx="12" cy="12" r="1.5" fill="currentColor"/></>,
    compare: <><rect x="3" y="12" width="5" height="9" rx="1" fill="none" strokeWidth="1.8"/><rect x="10" y="7" width="5" height="14" rx="1" fill="none" strokeWidth="1.8"/><rect x="17" y="3" width="5" height="18" rx="1" fill="none" strokeWidth="1.8"/></>,
    enterprise: <><rect x="3" y="6" width="18" height="15" rx="2" fill="none" strokeWidth="1.8"/><path d="M3 10h18" strokeWidth="1.5"/><circle cx="7" cy="15" r="1.5" fill="currentColor"/><circle cx="12" cy="15" r="1.5" fill="currentColor"/><circle cx="17" cy="15" r="1.5" fill="currentColor"/></>,
  };
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeLinecap="round">
      {icons[type]}
    </svg>
  );
}

/* ═══════════════════════════════════════
   FAQ ACCORDION
   ═══════════════════════════════════════ */
function FAQ() {
  const [open, setOpen] = useState(null);
  return (
    <div className="exp__faq-list">
      {FAQ_DATA.map((item, i) => (
        <div key={i} className={`exp__faq-item${open === i ? ' exp__faq-item--open' : ''}`}>
          <button className="exp__faq-q" onClick={() => setOpen(open === i ? null : i)} type="button">
            <span>{item.q}</span>
            <span className="exp__faq-toggle">{open === i ? '−' : '+'}</span>
          </button>
          {open === i && <div className="exp__faq-a">{item.a}</div>}
        </div>
      ))}
    </div>
  );
}

/* ═══════════════════════════════════════
   SIGNUP FORM
   ═══════════════════════════════════════ */
function SignupForm() {
  const [formData, setFormData] = useState({ name: '', email: '', isBetaTester: false });
  const [focused, setFocused] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const e = {};
    if (!formData.name.trim()) e.name = 'Name is required';
    if (!formData.email.trim()) e.email = 'Email is required';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) e.email = 'Enter a valid email';
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const onChange = (f, v) => {
    setFormData(p => ({ ...p, [f]: v }));
    if (errors[f]) setErrors(p => ({ ...p, [f]: '' }));
  };

  const onSubmit = async () => {
    if (!validate()) return;
    setSubmitting(true); setErrors({});
    try {
      await send('service_2idz8kw', 'template_z0bju65', {
        name: formData.name, email: formData.email,
        betaTester: formData.isBetaTester ? 'Yes' : 'No',
      }, 'qSp_483cmAMmnfRWN');
      setSubmitted(true);
      setFormData({ name: '', email: '', isBetaTester: false });
    } catch (err) {
      setErrors({ submit: 'Failed to submit. Please try again.' });
    } finally { setSubmitting(false); }
  };

  if (submitted) {
    return (
      <div className="exp__form-card exp__form-card--success">
        <div className="exp__form-success-icon"><CheckIcon className="exp__form-check" /></div>
        <div className="exp__form-success-title">Welcome Aboard!</div>
        <p className="exp__muted" style={{ marginBottom: 20 }}>Your participation has been recorded. Thank you for joining us.</p>
        <a href="https://drive.google.com/file/d/1LGa4kFDUblDtpgjMk9ayniFpX0nyLz3s/view?pli=1"
          className="exp__btn-primary" target="_blank" rel="noopener noreferrer">
          <DownloadIcon className="exp__btn-icon" /> Download Guide
        </a>
        <button className="exp__form-again" onClick={() => setSubmitted(false)} type="button">Submit another form</button>
      </div>
    );
  }

  return (
    <div className="exp__form-card">
      <div className="exp__form-header">
        <div className="exp__form-header-title">Get Started</div>
        <p className="exp__form-header-sub">Join our community and unlock all features</p>
      </div>
      <div className="exp__form-body">
        <div className={`exp__field${errors.name ? ' exp__field--err' : ''}`}>
          <label className="exp__field-label">Full Name</label>
          <div className="exp__input-wrap">
            <UserIcon className={`exp__input-icon${focused === 'name' ? ' exp__input-icon--on' : ''}`} />
            <input type="text" placeholder="Enter your full name" value={formData.name}
              onChange={e => onChange('name', e.target.value)}
              onFocus={() => setFocused('name')} onBlur={() => setFocused('')} />
          </div>
          {errors.name && <span className="exp__field-err">{errors.name}</span>}
        </div>
        <div className={`exp__field${errors.email ? ' exp__field--err' : ''}`}>
          <label className="exp__field-label">Email Address</label>
          <div className="exp__input-wrap">
            <MailIcon className={`exp__input-icon${focused === 'email' ? ' exp__input-icon--on' : ''}`} />
            <input type="email" placeholder="Enter your email" value={formData.email}
              onChange={e => onChange('email', e.target.value)}
              onFocus={() => setFocused('email')} onBlur={() => setFocused('')} />
          </div>
          {errors.email && <span className="exp__field-err">{errors.email}</span>}
        </div>
        <label className="exp__checkbox">
          <input type="checkbox" checked={formData.isBetaTester} onChange={e => onChange('isBetaTester', e.target.checked)} />
          <div>
            <span className="exp__checkbox-title">Beta Tester Program</span>
            <span className="exp__checkbox-desc">Get early access to features and shape our product</span>
          </div>
        </label>
        {errors.submit && <div className="exp__form-error">{errors.submit}</div>}
        <button className="exp__btn-primary exp__btn-full" onClick={onSubmit} disabled={submitting} type="button">
          {submitting ? <><LoaderIcon className="exp__btn-icon exp__spin" /> Processing...</> : 'Get Started'}
        </button>
        <p className="exp__form-disclaimer">By submitting, you agree to our terms and privacy policy.</p>
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════
   MAIN COMPONENT
   ═══════════════════════════════════════ */
function ExplorePage() {
  const [activeFeature, setActiveFeature] = useState(0);

  return (
    <div className="exp__page">
      <Navbar />

      {/* HERO */}
      <section className="exp__hero">
        <div className="exp__hero-inner">
          <div className="exp__hero-content">
            <span className="exp__tag">Explore SOMFIN</span>
            <div className="exp__hero-title">Everything you need<br />to master your finances.</div>
            <p className="exp__hero-sub">From personal budgeting to enterprise analytics — explore the full platform, see how it works, and join thousands building financial clarity.</p>
            <div className="exp__hero-actions">
              <a href="#get-started" className="exp__btn-primary">Join the Platform <span>↓</span></a>
              <a href="#how-it-works" className="exp__btn-outline">See How It Works</a>
            </div>
          </div>
          <div className="exp__hero-illust">
            <IllustrationDashboard />
          </div>
        </div>
      </section>

      {/* PLATFORM OVERVIEW */}
      <section className="exp__section exp__section--overview">
        <div className="exp__inner">
          <div className="exp__section-header">
            <span className="exp__tag">Platform</span>
            <div className="exp__section-title">What SOMFIN Offers</div>
            <p className="exp__section-sub">Six pillars of financial intelligence — from personal budgeting to enterprise-grade analytics.</p>
          </div>
          <div className="exp__features-grid">
            {PLATFORM_FEATURES.map((f, i) => (
              <div key={i} className={`exp__feat-card${activeFeature === i ? ' exp__feat-card--on' : ''}`}
                onClick={() => setActiveFeature(i)} role="button" tabIndex={0}
                onKeyDown={e => e.key === 'Enter' && setActiveFeature(i)}>
                <div className="exp__feat-icon"><FeatureIcon type={f.icon} /></div>
                <div className="exp__feat-title">{f.title}</div>
                <p className="exp__feat-desc">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="exp__section exp__section--how" id="how-it-works">
        <div className="exp__inner">
          <div className="exp__section-header">
            <span className="exp__tag">How It Works</span>
            <div className="exp__section-title">From Zero to Financially Aware</div>
            <p className="exp__section-sub">Four steps to transform your relationship with money.</p>
          </div>
          <div className="exp__steps">
            {HOW_IT_WORKS.map((s, i) => (
              <div key={i} className="exp__step">
                <div className="exp__step-num">{s.step}</div>
                <div className="exp__step-content">
                  <div className="exp__step-title">{s.title}</div>
                  <p className="exp__step-desc">{s.desc}</p>
                </div>
                {i < HOW_IT_WORKS.length - 1 && <div className="exp__step-line" />}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* VISUAL STRIP */}
      <section className="exp__section exp__section--visual">
        <div className="exp__inner">
          <div className="exp__visual-grid">
            <div className="exp__visual-card">
              <IllustrationShield />
              <div className="exp__visual-title">Bank-Grade Security</div>
              <p className="exp__muted">AES-256 encryption, SOC 2 compliance, and zero data selling — ever.</p>
            </div>
            <div className="exp__visual-card">
              <IllustrationChart />
              <div className="exp__visual-title">Real-Time Insights</div>
              <p className="exp__muted">Every calculation updates instantly as you adjust inputs — no page refreshes.</p>
            </div>
            <div className="exp__visual-card">
              <IllustrationGears />
              <div className="exp__visual-title">Built for India</div>
              <p className="exp__muted">EPF, PPF, NPS, ELSS, GST, Section 80C — all Indian frameworks built in.</p>
            </div>
          </div>
        </div>
      </section>

      {/* USE CASES */}
      <section className="exp__section exp__section--usecases">
        <div className="exp__inner">
          <div className="exp__section-header">
            <span className="exp__tag">Who It's For</span>
            <div className="exp__section-title">Designed for Every Financial Journey</div>
          </div>
          <div className="exp__usecases-grid">
            {USE_CASES.map((u, i) => (
              <div key={i} className="exp__usecase" style={{ '--uc-accent': u.accent }}>
                <div className="exp__usecase-who">{u.who}</div>
                <div className="exp__usecase-list">
                  {u.items.map((item, j) => <div key={j} className="exp__usecase-item">✓ {item}</div>)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="exp__section exp__section--faq">
        <div className="exp__inner">
          <div className="exp__section-header">
            <span className="exp__tag">FAQ</span>
            <div className="exp__section-title">Common Questions</div>
          </div>
          <FAQ />
        </div>
      </section>

      {/* SIGNUP */}
      <section className="exp__section exp__section--signup" id="get-started">
        <div className="exp__inner">
          <div className="exp__signup-grid">
            <div className="exp__signup-content">
              <div className="exp__section-title" style={{ textAlign: 'left' }}>Start your financial<br />journey today.</div>
              <p className="exp__muted" style={{ maxWidth: 400, marginTop: 12, fontSize: 15 }}>
                Join our community of individuals and businesses building financial clarity. Free to start, no credit card required.
              </p>
              <div className="exp__signup-stats">
                <div><strong>1,000+</strong><span>Users Onboarded</span></div>
                <div><strong>50+</strong><span>Tools Available</span></div>
                <div><strong>96%</strong><span>Satisfaction</span></div>
              </div>
            </div>
            <SignupForm />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default ExplorePage;